module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-a1756b326971e1c3ea0eb1799355cf23.png";